import { Dispatch, FC, SetStateAction, createContext } from 'react';

export type WebFormContextType = {
  form: {
    id: number;
    name: string;
    slug: string;
    data: Record<string, any>;
    isFilled: boolean;
    filledAt: string | null;
  };
  step: number;
  totalSteps: number;
  steps: FC[];
  setStep: Dispatch<SetStateAction<WebFormContextType['step']>>;
  setForm: Dispatch<SetStateAction<WebFormContextType['form']>>;
  Overview: FC;
};

export const WebFormContext = createContext<WebFormContextType>({} as any);
